import apiClient from "./apiService";

// Fetch reviews
export const fetchReviews = async (page = 1) => {
  try {
    const response = await apiClient.get(
      `/admin/product-ratings/admin-index?page=${page}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete review
export const deleteReview = async (id) => {
  try {
    const response = await apiClient.delete(`/admin/product-ratings/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
